import * as constants from 'frontend/routes/constants'
import cycleTimeDiagramRoutes from 'frontend/routes/cycleTimeDiagramRoutes'
import initialRouter from 'frontend/router'
import standardTimeMeasurementRoutes from 'frontend/routes/standard-time-measurements'
import { accountRoutes } from 'frontend/routes/account'
import {
  ACTIONS,
  DAILYROUND_MESSAGES,
  DIAGNOSIS_FACTORY,
  DIAGNOSIS_LINE,
  DR,
  GEMBA_WALK,
  LPA,
  MY_CALENDAR,
  OK_FIRST_PART,
  OVERVIEW,
  PROBLEM_SOLVING,
  PRODUCTION_FORMAT,
  STANDARD_WORK_REVIEW,
  TASK_MANAGER,
  TASK_MANAGER_ASSIGNMENT,
  VS,
  VT_RESULTS,
} from 'frontend/constants/callers'
import {
  CATEGORIES_DETAILS_SETTINGS_ROUTE,
  CATEGORIES_SETTINGS_ROUTE,
  DASHBOARD_MODULE_TOKENS,
  SETTINGS_CARDS_TOKENS,
  WEEKLY_MEETING_SETTINGS_ROUTE,
} from 'frontend/constants/settings'
import { CONFIGURATION_KEYS } from 'frontcore/constants/constants'
import {
  CONSOLIDATED_REPORT_FILTERS,
  DEFECTS_FILTERS,
  DIAGNOSIS_FILTERS,
  OK_FIRST_PART_CHECK_POINT_FILTERS,
  PRODUCTS_FILTERS,
  REFERENCE_STATE_FILTERS,
  TEMPLATE_FILTERS,
  TPM_COMPLETE_TASKS_FILTERS,
  TPM_GROUP_TASKS_FILTERS,
  VS_EVALUATION_RESULTS_FILTERS,
  VS_FILTERS,
} from 'frontend/constants/filterUrls'
import { DAILYROUND_CHECKPOINT } from 'frontend/constants/drCheckpoints'
import { GEMBA_WALK_TEMPLATE } from 'frontend/constants/gembaWalk'
import { HSE_PRIORITIES_ORIGIN } from 'frontend/constants/hse'
import { LPAS_SOURCE, MASTER_AUDIT_SOURCE } from 'frontend/constants/audit'
import { OK_FIRST_PART_SOURCE } from 'frontend/constants/okFirstPart'
import { PROBLEM_RESOLUTION_SOURCE, PROBLEM_TABS, SOURCE_MTOOL, SOURCE_SIXMTOOL } from 'frontend/constants/problems'
import { PRODUCTION_FORMAT_SOURCE } from 'frontend/constants/productionFormat'
import { SUPER_CATEGORIES, TASK_MANAGER as TASK_MANAGER_SOURCE } from 'frontcore/constants/taskManager'
import { SWR_SOURCE } from 'frontend/constants/standardWorkReview'
import { URL_BASE_AUDIT_SUBSOURCES } from 'frontend/communications/templates'
import { VS_BUNDLE_ID } from 'frontend/constants/standards'
import { VT_SOURCE } from 'frontend/constants/virtualTraining'

const ActionsCalendarPage = () => import('frontend/pages/actions/ActionsCalendarPage')
const ActionsDetailsPage = () => import('frontend/pages/actions/ActionsDetailsPage')
const ActionsFollowUpTeamsPage = () => import('frontend/pages/actions/ActionsFollowUpTeamsPage')
const ActionsOverviewPage = () => import('frontend/pages/actions/ActionsOverviewPage')
const ActionsPage = () => import('frontend/pages/actions/ActionsPage')
const ActivityDetails = () => import('frontend/components/DRCheckpoints/ActivityDetails')
const AuditActionEvidencesConfigurationPage = () => import('frontend/pages/settings/audits/AuditActionEvidencesConfigurationPage')
const AuditsCalendarPage = () => import('frontend/pages/audits/CalendarPage')
const AuditsChartsConfigurationPage = () => import('frontend/pages/settings/audits/AuditsChartsConfigurationPage')
const AuditsFilters = () => import('frontend/presentation/audits/filters/views/AuditsFilters')
const AuditsListPage = () => import('frontend/pages/audits/ListPage')
const AuditsOverviewPage = () => import('frontend/pages/audits/OverviewPage')
const AuditsPage = () => import('frontend/pages/audits/AuditsPage')
const BackButton = () => import('frontend/components/core/BackButton')
const ChartsTablesConfigurationPage = () => import('frontend/pages/settings/ChartsTableConfigurationPage')
const ChecklistPage = () => import('frontend/pages/dailyround/ChecklistPage')
const CompletedTaskDetails = () => import('frontend/pages/completedTasks/CompletedTasksDetails')
const CompletedTasksGroupDetails = () => import('frontend/pages/completedTasks/CompletedTasksGroupDetails')
const CompletedTasksGroups = () => import('frontend/pages/completedTasks/CompletedTasksGroups')
const CompletedTasksLayoutWrapper = () => import('frontend/components/completedTasks/CompletedTasksLayoutWrapper')
const CompletedTasksList = () => import('frontend/pages/completedTasks/CompletedTaskList')
const CompletedTasksOverview = () => import('frontend/pages/completedTasks/CompletedTasksOverview')
const CompletedTasksPage = () => import('frontend/pages/completedTasks/CompletedTaskPage')
const ComplianceEvaluationReasonsPage = () => import('frontend/pages/settings/ComplianceEvaluationReasonsPage')
const ComplianceThresholdsPage = () => import('frontend/pages/settings/ComplianceThresholdsPage')
const ConsolidatedReportCreation = () => import('frontend/pages/diagnosis/ConsolidatedReportCreation')
const ConsolidatedReportDetail = () => import('frontend/pages/diagnosis/ConsolidatedReportDetail')
const ConsolidatedReportPage = () => import('frontend/pages/diagnosis/ConsolidatedReportPage')
const ConsolidatedReportTablePage = () => import('frontend/pages/diagnosis/ConsolidatedReportTablePage')
const DailyRoundPage = () => import('frontend/pages/dailyround/DailyRoundPage')
const DetailsAction = () => import('frontend/components/actions/DetailsAction')
const DetailsDailyRound = () => import('frontend/components/dailyround/DetailsDailyRound')
const DetailsPage = () => import('frontend/components/audits/DetailsPage')
const DiagnosisBricks = () => import('frontend/components/diagnosis/DiagnosisBricks')
const DiagnosisDetailPage = () => import('frontend/pages/diagnosis/DiagnosisDetailPage')
const DiagnosisListPage = () => import('frontend/pages/diagnosis/DiagnosisListPage')
const DiagnosisOverviewPage = () => import('frontend/pages/diagnosis/DiagnosisOverviewPage')
const DiagnosisPage = () => import('frontend/pages/diagnosis/DiagnosisPage')
const DRCheckpointsDetails = () => import('frontend/components/DRCheckpoints/DRCheckpointsDetails')
const DRCheckpointsList = () => import('frontend/pages/DRCheckpoints/DRCheckpointsListPage')
const DRCheckpointsOverviewPage = () => import('frontend/pages/DRCheckpoints/DRCheckpointsOverviewPage')
const DRCheckpointsPage = () => import('frontend/pages/DRCheckpoints/DRCheckpointsPage')
const DRCheckpointsRoundsDetails = () => import('frontend/components/DRCheckpoints/DRCheckpointsRoundsDetails')
const DRCheckpointsRoundsList = () => import('frontend/pages/DRCheckpoints/DRCheckpointsRoundsList')
const DRLogBook = () => import('frontend/pages/DRCheckpoints/DRLogBook')
const DRLogBookDetails = () => import('frontend/pages/DRCheckpoints/DRLogBookDetails')
const DRWeeklyRoundReview = () => import('frontend/pages/DRCheckpoints/DRWeeklyRoundReview')
const ExecutiveViewPage = () => import('frontend/presentation/problem-solving/executive-view/views/ExecutiveViewPage')
const FaceToFaceDetails = () => import('frontend/pages/GWCheckpoints/FaceToFaceDetails')
const FaceToFaceList = () => import('frontend/pages/GWCheckpoints/FaceToFaceList')
const FiveSDefectsDetailsPage = () => import('frontend/pages/5S/DefectsDetailsPage')
const FiveSDefectsPage = () => import('frontend/pages/5S/DefectsPage')
const FundamentalDetail = () => import('frontend/components/diagnosis/FundamentalDetail')
const GWByCheckpointDetailsPage = () => import('frontend/pages/GWCheckpoints/GWByCheckpointDetailsPage')
const GWByCheckpointListPage = () => import('frontend/pages/GWCheckpoints/GWByCheckpointListPage')
const GWCheckpointsDetails = () => import('frontend/components/GWCheckpoints/GWCheckpointsDetails')
const GWCheckpointsList = () => import('frontend/pages/GWCheckpoints/GWCheckpointsList')
const GWCheckpointsOverviewPage = () => import('frontend/pages/GWCheckpoints/GWCheckpointsOverviewPage')
const GWCheckpointsPage = () => import('frontend/pages/GWCheckpoints/GWCheckpointsPage')
const GWCheckpointsSchedulesActivityDetails = () => import('frontend/pages/GWCheckpoints/GWCheckpointsSchedulesActivityDetails')
const GWCheckpointsSchedulesDetails = () => import('frontend/pages/GWCheckpoints/GWCheckpointsSchedulesDetails')
const GWCheckpointsSchedulesList = () => import('frontend/pages/GWCheckpoints/GWCheckpointsSchedulesList')
const HeaderFactoryStructure = () => import('frontend/components/core/HeaderFactoryStructure')
const HistoryPage = () => import('frontend/pages/dailyround/HistoryPage')
const LPAPage = () => import('frontend/pages/lpa/LPAPage')
const LPATemplateAssignmentPage = () => import('frontend/pages/lpa/LPATemplateAssignmentPage')
const MyCalendarOverview = () => import('frontend/pages/myCalendar/MyCalendarOverview')
const MyCalendarPage = () => import('frontend/pages/myCalendar/MyCalendarPage')
const ObserversPage = () => import('frontend/pages/settings/ObserversPage')
const OkFirstPartCheckpointVersionsPage = () => import('frontend/pages/okFirstPart/OkFirstPartCheckpointVersionsPage')
const OkFirstPartDefinitionDetails = () => import('frontend/pages/okFirstPart/OkFirstPartDefinitionDetails')
const OkFirstPartDefinitionList = () => import('frontend/pages/okFirstPart/OkFirstPartDefinitionList')
const OkFirstPartPage = () => import('frontend/pages/okFirstPart/OkFirstPartPage')
const OverviewPage = () => import('frontend/pages/OverviewPage')
const OverviewProblemSolving = () => import('frontend/pages/problemResolution/ProblemOverview')
const PendingItems = () => import('frontend/pages/pending/PendingItems')
const PendingPage = () => import('frontend/pages/pending/PendingPage')
const PermissionsPage = () => import('frontend/pages/settings/PermissionsPage')
const ProblemsList = () => import('frontend/pages/problemResolution/ProblemListPage')
const ProblemSolvingDetails = () => import('frontend/components/problemResolution/ProblemResolutionDetails')
const ProblemSolvingPage = () => import('frontend/pages/problemResolution/ProblemResolutionPage')
const ProblemSolvingPlanningPage = () => import('frontend/pages/problemResolution/ProblemSolvingPlanningPage')
const ReferenceState = () => import('frontend/pages/5S/ReferenceState')
const ReferenceStateTabs = () => import('frontend/components/5S/referenceState/ReferenceStateTabs')
const RemoteFilters = () => import('frontcore/presentation/remote-filters/views/RemoteFilters.vue')
const RootCauseDetails = () => import('frontend/pages/problemResolution/RootCauseDetails')
const SettingsActionPlanEfficiencyConfiguration = () => import('frontend/pages/settings/problemSolving/SettingsActionPlanEfficiencyConfiguration')
const SettingsAssessmentHistoryGraphPage = () => import('frontend/pages/settings/SettingsAssessmentHistoryGraphPage')
const SettingsAuditsPlannerConfiguration = () => import('frontend/pages/settings/SettingsAuditsPlannerConfiguration')
const SettingsCategories = () => import('frontend/pages/settings/SettingsCategories')
const SettingsCategoriesDetailsPage = () => import('frontend/pages/settings/SettingsCategoriesDetailsPage')
const SettingsConsolidatedReportRolePermissionssPage = () => import('frontend/pages/settings/SettingsConsolidatedReportRolePermissionssPage')
const SettingsDiagnosisRolePermissionssPage = () => import('frontend/pages/settings/SettingsDiagnosisRolePermissionssPage')
const SettingsFundamentalTargetPage = () => import('frontend/pages/settings/diagnosis/SettingsFundamentalTargetPage')
const SettingsGWByCheckpointsChartConfigurationPage = () => import('frontend/pages/settings/GWCheckpoints/SettingsGWByCheckpointsChartConfigurationPage')
const SettingsGWCheckpointsChartConfigurationPage = () => import('frontend/pages/settings/GWCheckpoints/SettingsGWCheckpointsChartConfigurationPage')
const SettingsHSERiskPrioritiesPage = () => import('frontend/pages/settings/hse/SettingsHSERiskPrioritiesPage')
const SettingsHSERiskPriorityDetails = () => import('frontend/pages/settings/hse/SettingsHSERiskPriorityDetails')
const SettingsNoCompliancesPage = () => import('frontend/pages/settings/SettingsNoCompliancesPage')
const SettingsOkFirstPartByCheckpointChartConfigurationPage = () => import('frontend/pages/settings/OkFirstPart/SettingsOkFirstPartByCheckpointChartConfigurationPage')
const SettingsOkFirstPartChartConfigurationPage = () => import('frontend/pages/settings/OkFirstPart/SettingsOkFirstPartChartConfigurationPage')
const SettingsOkFirstPartEmailsPage = () => import('frontend/pages/settings/OkFirstPart/SettingsOkFirstPartEmailsPage')
const SettingsOkFirstPartOptionsPage = () => import('frontend/pages/settings/OkFirstPart/SettingsOkFirstPartOptionsPage')
const SettingsOverviewPage = () => import('frontend/pages/settings/SettingsOverviewPage')
const SettingsPage = () => import('frontend/pages/settings/SettingsPage')
const SettingsPresentationNotifications = () => import('frontend/pages/settings/SettingsPresentationNotifications')
const SettingsPreviousCommentsTime = () => import('frontend/pages/settings/SettingsPreviousCommentsTime')
const SettingsProblemCloseToolsConfiguration = () => import('frontend/pages/settings/problemSolving/SettingsProblemCloseToolsConfiguration')
const SettingsProblemSolvingActionCategoriesPage = () => import('frontend/presentation/problem-solving/configuration/actions-categories-configuration/views/SettingsProblemSolvingActionCategoriesPage')
const SettingsProblemSolvingCauseTool = () => import('frontend/pages/settings/problemSolving/SettingsProblemSolvingCauseTool')
const SettingsProblemSolvingDocumentationReview = () => import('frontend/pages/settings/problemSolving/SettingsProblemSolvingDocumentationReview')
const SettingsProblemSolvingFields = () => import('frontend/pages/settings/problemSolving/SettingsProblemSolvingFields')
const SettingsProductionFormatDetailsPage = () => import('frontend/pages/settings/products/SettingsProductionFormatDetails')
const SettingsProductionFormatPage = () => import('frontend/pages/settings/products/SettingsProductionFormatPage')
const SettingsQualityFailuresPage = () => import('frontend/pages/settings/SettingsQualityFailuresPage')
const SettingsSelfAssessmentOverviewPage = () => import('frontend/pages/settings/diagnosis/SettingsSelfAssessmentOverviewPage')
const SettingsStandardAbilityCertificateDetail = () => import("frontend/pages/settings/standards/SettingsStandardAbilityCertificateDetail")
const SettingsStandardAbilityCertifications = () => import('frontend/pages/settings/standards/SettingsStandardAbilityCertificationsList.vue')
const SettingsStandardErgonomicsLevelDetail = () => import('frontend/pages/settings/standards/SettingsStandardErgonomicsLevelDetail')
const SettingsStandardErgonomicsLevels = () => import('frontend/pages/settings/standards/SettingsStandardErgonomicsLevels')
const SettingsStandardKpisCharts = () => import('frontend/pages/settings/standards/SettingsStandardKpisCharts')
const SettingsStandardProductionConfigurationDetails = () => import('frontend/pages/settings/standards/SettingsStandardProductionConfigurationDetails')
const SettingsStandardProductionConfigurationsList = () => import('frontend/pages/settings/standards/SettingsStandardProductionConfigurationsList')
const SettingsStandardViewer = () => import('frontend/pages/settings/standards/SettingsStandardViewer')
const SettingsSuperCategories = () => import('frontend/pages/settings/SettingsSuperCategories')
const SettingsSuperCategoriesDetails = () => import('frontend/pages/settings/SettingsSuperCategoriesDetails')
const SettingsSuperCategoriesPage = () => import('frontend/pages/settings/SettingsSuperCategoriesPage')
const SettingsTemplates = () => import('frontend/pages/settings/SettingsTemplates')
const SettingsTPMCheckpointOptionsPage = () => import('frontend/pages/settings/SettingsTPMCheckpointOptionsPage')
const SettingsWeeklyMeeting = () => import('frontend/pages/settings/SettingsWeeklyMeeting')
const SettingsSkillMatrixPeopleIdentifierFormatPage = () => import('frontend/pages/settings/skill_matrix/SettingsSkillMatrixPeopleIdentifierFormatPage.vue')
const SevenWasteDetailsPage = () => import('frontend/pages/standards/seven-wastes/view/SevenWasteDetailsPage')
const SevenWastesListPage = () => import(/* webpackChunkName: "seven-wastes-list" */ 'frontend/pages/standards/seven-wastes/view/SevenWastesListPage')
const SevenWastesTable = () => import(/* webpackChunkName: "seven-wastes-list" */ 'frontend/components/standard/seven-wastes/SevenWastesTable')
const SkillMatrixBulkImportPage = () => import('frontend/presentation/skill-matrix/skill-matrix-bulk-import/views/SkillMatrixBulkImportPage')
const ProductsBulkImportPage = () => import('frontend/presentation/products/products-bulk-import/views/ProductsBulkImportPage')
const StandardEvaluationDetailPage = () => import('frontend/pages/standards/StandardEvaluationDetailPage')
const StandardEvaluationPage = () => import('frontend/pages/standards/StandardEvaluationPage')
const StandardEvaluationResultsPage = () => import('frontend/pages/standards/StandardEvaluationResultsPage')
const StandardListPage = () => import('frontend/pages/standards/StandardListPage')
const StandardOverviewPage = () => import('frontend/pages/standards/StandardOverviewPage')
const StandardReferenceStandardsPage = () => import('frontend/pages/standards/StandardReferenceStandardsPage')
const StandardsPage = () => import('frontend/pages/standards/StandardPage')
const StandardSummaryPage = () => import('frontend/pages/standards/standard-summary/view/StandardSummaryPage')
const StandardTabsContainer = () => import('frontend/components/standard/StandardTabsContainer.vue')
const StandardVersionListPage = () => import('frontend/pages/standards/StandardVersionListPage')
const StandardViewerPage = () => import('frontend/presentation/standard-viewer/view/StandardViewerPage.vue')
const StandardWorkReviewPage = () => import('frontend/pages/standardWorkReview/StandardWorkReviewPage')
const SWACalendarPage = () => import(/* webpackChunkName: "swa-calendar" */ 'frontend/pages/standardWorkReview/SWACalendarPage')
const SWAMonthlyCalendar = () => import(/* webpackChunkName: "swa-calendar" */ 'frontend/pages/standardWorkReview/SWAMonthlyCalendarPage')
const SWAWeeklyCalendarPage = () => import(/* webpackChunkName: "swa-calendar" */ 'frontend/pages/standardWorkReview/SWAWeeklyCalendarPage')
const SWRDetailPage = () => import('frontend/pages/standardWorkReview/SWRDetailPage')
const SWREvaluationDetailPage = () => import('frontend/pages/standardWorkReview/SWREvaluationDetailPage')
const SWRListPage = () => import('frontend/pages/standardWorkReview/SWRListPage')
const SWROverviewPage = () => import('frontend/pages/standardWorkReview/SWROverviewPage')
const SWRVariabilityPage = () => import('frontend/pages/standardWorkReview/SWRVariabilityPage')
const TaskDetails = () => import('frontend/pages/tasksDefinition/TaskDetailsPage')
const TaskGroupsPage = () => import('frontend/pages/tasksDefinition/TaskGroupsPage')
const TaskGroupsPlanningPage = () => import('frontend/pages/tasksDefinition/TaskGroupsPlanningPage')
const TaskManagerPage = () => import('frontend/pages/tasksDefinition/TaskManagerPage')
const TasksAssignment = () => import('frontend/pages/tasksDefinition/TasksAssignment')
const TasksGroupsAnnualPlanning = () => import('frontend/components/tasksDefinition/TasksGroupsAnnualPlanning')
const TasksGroupsAnnualPlanningDetails = () => import('frontend/components/tasksDefinition/TasksGroupsAnnualPlanningDetails')
const TasksList = () => import('frontend/pages/tasksDefinition/TasksListPage')
const VariantEvaluationPage = () => import('frontend/pages/VirtualTraining/VariantEvaluationPage')
const VariantViewerPage = () => import('frontend/pages/VirtualTraining/VariantViewerPage')
const VirtualTrainingPage = () => import('frontend/pages/VirtualTraining/VirtualTrainingPage')
const VirtualTrainingStatePage = () => import('frontend/pages/VirtualTraining/VirtualTrainingStatePage')
const VirtualTrainingTestResultsPage = () => import('frontend/pages/VirtualTraining/VirtualTrainingTestResultsPage')
const VTCharts = () => import('frontend/components/VT/VTCharts')
const VTOverview = () => import('frontend/pages/VirtualTraining/OverviewPage')

export const router = initialRouter

export const dailyroundRoutes = [
  {
    name: DASHBOARD_MODULE_TOKENS.dailyroundOld.name,
    path: '/daily-round',
    component: DailyRoundPage,
    redirect: { name: DASHBOARD_MODULE_TOKENS.dailyroundChecklistOld.name },
    children: [
      {
        shownInMenu: true,
        path: 'checklist',
        name: DASHBOARD_MODULE_TOKENS.dailyroundChecklistOld.name,
        components: {
          default: ChecklistPage,
          header: HeaderFactoryStructure,
        },
        props: {
          default: { caller: DR },
          header: { caller: DR },
        },
      },
      {
        shownInMenu: true,
        path: 'list',
        name: DASHBOARD_MODULE_TOKENS.dailyroundListOld.name,
        components: {
          default: HistoryPage,
          header: HeaderFactoryStructure,
        },
        props: {
          default: { caller: DR, source: 'dailyround' },
          header: { caller: DR, source: 'dailyround' },
        },
      },
      {
        shownInMenu: false,
        path: 'list/:id',
        name: 'dailyround-details',
        component: DetailsDailyRound,
      },
    ],
  },
]

export const standardViewerRoutes = [
  {
    path: '/visual-standards',
    name: DASHBOARD_MODULE_TOKENS.standards.name,
    component: StandardsPage,
    children: [
      ...cycleTimeDiagramRoutes,
      {
        shownInMenu: true,
        path: 'viewer/:id?',
        name: DASHBOARD_MODULE_TOKENS.standardViewer.name,
        components: {
          default: StandardViewerPage,
          header: HeaderFactoryStructure,
        },
        props: {
          default: { caller: VS },
          header: { caller: VS, multiple: false, anyLevelClickable: false },
        },
      },
      {
        shownInMenu: true,
        path: 'evaluation',
        name: DASHBOARD_MODULE_TOKENS.standardEvaluation.name,
        components: {
          default: StandardEvaluationPage,
        },
        props: {
          default: { caller: VS },
        },
      },
      {
        shownInMenu: true,
        path: 'overview',
        name: DASHBOARD_MODULE_TOKENS.standardOverview.name,
        components: {
          default: StandardOverviewPage,
          header: HeaderFactoryStructure,
        },
        props: {
          default: { caller: VS },
          header: { caller: VS },
        },
      },
      {
        shownInMenu: true,
        path: 'list',
        name: DASHBOARD_MODULE_TOKENS.standardList.name,
        components: {
          default: StandardListPage,
          filters: RemoteFilters,
          header: HeaderFactoryStructure,
        },
        props: {
          default: { caller: VS },
          filters: { filterURL: VS_FILTERS },
          header: { caller: VS },
        },
      },
      {
        shownInMenu: false,
        path: 'list/versions/:id',
        name: DASHBOARD_MODULE_TOKENS.standardVersionList.name,
        components: {
          default: StandardVersionListPage,
        },
        props: {
          default: (routerInstance) => {
            return {
              caller: VS,
              id: Number(routerInstance.params.id),
              standard: routerInstance.params.standard,
            }
          },
        },
      },
      {
        shownInMenu: false,
        path: 'summary/:standardId',
        name: DASHBOARD_MODULE_TOKENS.standardSummary.name,
        components: {
          default: StandardSummaryPage,
        },
        props: {
          default: (routerInstance) => {
            return {
              standardId: Number(routerInstance.params.standardId),
            }
          },
        },
      },
      {
        shownInMenu: false,
        path: 'details/:id',
        name: DASHBOARD_MODULE_TOKENS.standardDetails.name,
        components: {
          default: StandardTabsContainer,
        },
        props: {
          default: (routerInstance) => {
            return {
              standardId: Number(routerInstance.params.id),
              key: Number(routerInstance.name),
            }
          },
        },
      },
      {
        shownInMenu: false,
        path: 'seven-wastes/:standardId',
        name: DASHBOARD_MODULE_TOKENS.standardSevenWastesList.name,
        components: {
          default: SevenWastesListPage,
        },
        props: {
          default: (routerInstance) => {
            return {
              standardId: Number(routerInstance.params.standardId),
            }
          },
        },
        redirect: { name: DASHBOARD_MODULE_TOKENS.standardOpenSevenWastesList.name },
        children: [
          {
            path: 'open',
            name: DASHBOARD_MODULE_TOKENS.standardOpenSevenWastesList.name,
            components: {
              default: SevenWastesTable,
            },
            props: {
              default: (routerInstance) => {
                return {
                  standardId: Number(routerInstance.params.standardId),
                  standardSevenWastesTableName: DASHBOARD_MODULE_TOKENS.standardOpenSevenWastesList.name,
                }
              },
            },
          },
          {
            path: 'closed',
            name: DASHBOARD_MODULE_TOKENS.standardClosedSevenWastesList.name,
            components: {
              default: SevenWastesTable,
            },
            props: {
              default: (routerInstance) => {
                return {
                  standardId: Number(routerInstance.params.standardId),
                  standardSevenWastesTableName: DASHBOARD_MODULE_TOKENS.standardClosedSevenWastesList.name,
                }
              },
            },
          },
        ],
      },
      ...standardTimeMeasurementRoutes,
      {
        shownInMenu: false,
        path: 'seven-wastes/:standardId/details/:sevenWasteId?',
        name: DASHBOARD_MODULE_TOKENS.standardSevenWasteDetails.name,
        components: {
          default: SevenWasteDetailsPage,
        },
        props: {
          default: (routerInstance) => {
            return {
              source: VS_BUNDLE_ID,
              standardId: Number(routerInstance.params.standardId),
              sevenWasteId: Number(routerInstance.params.sevenWasteId) || null,
            }
          },
        },
      },
      {
        shownInMenu: true,
        path: 'evaluations-results',
        name: DASHBOARD_MODULE_TOKENS.standardEvaluationResults.name,
        components: {
          default: StandardEvaluationResultsPage,
          header: HeaderFactoryStructure,
          filters: RemoteFilters,
        },
        props: {
          default: { caller: VS },
          header: { caller: VS },
          filters: { filterURL: VS_EVALUATION_RESULTS_FILTERS },
        },
      },
      {
        shownInMenu: false,
        path: 'evaluations-results/:id/type/:type',
        name: 'standard-evaluation-detail',
        components: {
          default: StandardEvaluationDetailPage,
        },
        props: {
          default: { caller: VS },
        },
      },
      {
        shownInMenu: true,
        path: DASHBOARD_MODULE_TOKENS.referenceStandard.name,
        name: DASHBOARD_MODULE_TOKENS.referenceStandard.name,
        components: {
          default: StandardReferenceStandardsPage,
          header: HeaderFactoryStructure,
        },
        props: {
          header: { caller: VS, multiple: false },
          default: { caller: VS },
        },
      },
    ],
  },
]

export const completedTasksRoutes = [
  {
    path: '/completed-tasks',
    name: DASHBOARD_MODULE_TOKENS.completedTasks.name,
    component: CompletedTasksPage,
    children: [
      {
        shownInMenu: true,
        path: 'list',
        name: DASHBOARD_MODULE_TOKENS.completedTasksList.name,
        components: {
          header: HeaderFactoryStructure,
          filters: RemoteFilters,
          default: CompletedTasksList,
        },
        props: {
          header: { caller: TASK_MANAGER },
          default: { source: TASK_MANAGER_SOURCE },
          filters: { filterURL: TPM_COMPLETE_TASKS_FILTERS },
        },
      },
      {
        shownInMenu: true,
        path: 'overview/:filters?',
        name: DASHBOARD_MODULE_TOKENS.completedTasksOverview.name,
        components: {
          header: HeaderFactoryStructure,
          filters: RemoteFilters,
          default: CompletedTasksOverview,
        },
        props: {
          header: { caller: TASK_MANAGER },
          default: { source: TASK_MANAGER_SOURCE },
          filters: { filterURL: TPM_COMPLETE_TASKS_FILTERS },
        },
      },
      {
        shownInMenu: true,
        path: 'layout/:filters?',
        name: DASHBOARD_MODULE_TOKENS.completedTasksLayout.name,
        components: {
          header: HeaderFactoryStructure,
          filters: RemoteFilters,
          default: CompletedTasksLayoutWrapper,
        },
        props: {
          header: { caller: TASK_MANAGER_ASSIGNMENT, multiple: false },
          default: { source: TASK_MANAGER_SOURCE, caller: TASK_MANAGER_ASSIGNMENT },
          filters: { filterURL: TPM_COMPLETE_TASKS_FILTERS },
        },
      },
      {
        shownInMenu: true,
        path: 'groups',
        name: DASHBOARD_MODULE_TOKENS.completedTasksGroups.name,
        components: {
          header: HeaderFactoryStructure,
          filters: RemoteFilters,
          default: CompletedTasksGroups,
        },
        props: {
          header: { caller: TASK_MANAGER_ASSIGNMENT },
          default: { source: TASK_MANAGER_SOURCE, caller: TASK_MANAGER_ASSIGNMENT },
          filters: { filterURL: TPM_GROUP_TASKS_FILTERS },
        },
      },
      {
        shownInMenu: false,
        path: 'groups/:id/type/:group_type',
        name: constants.COMPLETED_TASKS_BY_GROUP_DETAILS_ROUTE_NAME,
        components: {
          default: CompletedTasksGroupDetails,
        },
        props: {
          default: { source: TASK_MANAGER_SOURCE, caller: TASK_MANAGER_ASSIGNMENT },
        },
      },
      {
        shownInMenu: false,
        path: 'list/:id',
        name: constants.COMPLETED_TASKS_DETAILS_ROUTE_NAME,
        component: CompletedTaskDetails,
        props: { source: TASK_MANAGER_SOURCE },
      },
      {
        path: 'tasks-groups-planning',
        name: DASHBOARD_MODULE_TOKENS.tpmTasksPlanification.name,
        components: {
          header: HeaderFactoryStructure,
          filters: RemoteFilters,
          default: TaskGroupsPlanningPage,
        },
        props: {
          header: { caller: TASK_MANAGER_ASSIGNMENT },
          filters: { filterURL: TPM_GROUP_TASKS_FILTERS },
          default: { caller: TASK_MANAGER_ASSIGNMENT },
        },
        children: [
          {
            name: 'tasks-groups-planning-annual',
            path: 'annual',
            component: TasksGroupsAnnualPlanning,
          },
          {
            name: 'tasks-groups-planning-monthly',
            path: 'monthly',
            component: TasksGroupsAnnualPlanningDetails,
          },
        ],
      },
    ],
  },
]

export const problemSolvingRoutes = [
  {
    path: '/problem-solving',
    name: DASHBOARD_MODULE_TOKENS.problemSolving.name,
    component: ProblemSolvingPage,
    children: [
      {
        shownInMenu: true,
        path: 'overview',
        name: DASHBOARD_MODULE_TOKENS.problemSolvingOverview.name,
        components: {
          default: OverviewProblemSolving,
          header: HeaderFactoryStructure,
          filters: RemoteFilters,
        },
        props: {
          default: { caller: PROBLEM_SOLVING },
          header: { caller: PROBLEM_SOLVING },
        },
      },
      {
        shownInMenu: true,
        path: 'list',
        name: DASHBOARD_MODULE_TOKENS.problemSolvingList.name,
        components: {
          default: ProblemsList,
          header: HeaderFactoryStructure,
          filters: RemoteFilters,
        },
        props: {
          default: { caller: PROBLEM_SOLVING, source: PROBLEM_RESOLUTION_SOURCE },
          header: { caller: PROBLEM_SOLVING },
        },
      },
      {
        shownInMenu: false,
        path: 'list/:id',
        meta: { parentModulePermissionName: DASHBOARD_MODULE_TOKENS.problemSolvingList.name },
        redirect: to => {
          return { name: DASHBOARD_MODULE_TOKENS.problemSolvingDetails.name, params: { id: to.params.id, tab: PROBLEM_TABS.description.toString() } }
        },
      },
      {
        shownInMenu: false,
        path: 'list/:id/tab/:tabId?',
        name: DASHBOARD_MODULE_TOKENS.problemSolvingDetails.name,
        meta: {
          parentModulePermissionName: DASHBOARD_MODULE_TOKENS.problemSolvingList.name,
          keepScroll: true,
        },
        components: {
          default: ProblemSolvingDetails,
        },
        props: {
          default (routerInstance) {
            return {
              id: Number(routerInstance.params.id),
              tabId: Number(routerInstance.params.tabId ?? PROBLEM_TABS.description),
              source: PROBLEM_RESOLUTION_SOURCE,
            }
          },
        },
      },
      {
        shownInMenu: true,
        path: 'planification',
        name: DASHBOARD_MODULE_TOKENS.problemSolvingPlanning.name,
        components: {
          default: ProblemSolvingPlanningPage,
          header: HeaderFactoryStructure,
          filters: RemoteFilters,
        },
        props: {
          default: { caller: PROBLEM_SOLVING, source: PROBLEM_RESOLUTION_SOURCE },
          header: { caller: PROBLEM_SOLVING },
        },
      },
      {
        shownInMenu: false,
        path: 'executive-view/:id',
        name: DASHBOARD_MODULE_TOKENS.problemSolvingExecutiveView.name,
        meta: { parentModulePermissionName: DASHBOARD_MODULE_TOKENS.problemSolvingList.name },
        components: {
          default: ExecutiveViewPage,
        },
        props: {
          default: route => ({ problemId: Number(route.params.id) }),
        },
      },
      {
        path: constants.CAUSE_DETAILS_ROUTE + '/:problem' + '/:id?',
        name: constants.CAUSE_DETAILS_ROUTE,
        components: {
          default: RootCauseDetails,
        },
      },
    ],
  },
]

export const auditSettingsTemplateRoute = (source) => {
  return {
    path: `${source}`,
    name: SETTINGS_CARDS_TOKENS.settingTemplateConfiguration.name(source),
    components: {
      default: SettingsTemplates,
    },
    props: { default: { source } },
  }
}

export const auditSettingsObserversRoute = (source) => {
  return {
    path: `observers-${source}`,
    name: `settings-observers-${source}`,
    components: {
      default: ObserversPage,
    },
    props: {
      default: {
        source,
        caller: source.toUpperCase(),
      },
    },
  }
}

export const chartsConfigRoute = (source) => {
  return {
    path: `charts-config-${source}`,
    name: `settings-chartstable-config-${source}`,
    components: {
      default: AuditsChartsConfigurationPage,
    },
    props: {
      default: {
        source,
        caller: source.toUpperCase(),
      },
    },
  }
}

export const auditsActionsEvidencesRoute = (source) => {
  return {
    path: `settings-audits-actions-evidences-config-${source}`,
    name: `settings-audits-actions-evidences-config-${source}`,
    components: {
      default: AuditActionEvidencesConfigurationPage,
    },
    props: {
      default: {
        source,
        caller: source.toUpperCase(),
      },
    },
  }
}

export const auditSettingsPreviousCommentsTimeRoute = (source) => {
  return {
    path: SETTINGS_CARDS_TOKENS.auditsPreviousCommentsTimeConfiguration.name(source),
    name: SETTINGS_CARDS_TOKENS.auditsPreviousCommentsTimeConfiguration.name(source),
    components: {
      default: SettingsPreviousCommentsTime,
    },
    props: {
      default: {
        configurationKeyName: CONFIGURATION_KEYS.AUDITS_PREVIOUS_COMMENTS_TIME_CONFIG,
        caller: source.toUpperCase(),
      },
    },
  }
}

export const auditSettingsComplianceEvaluationReasonsRoute = (source) => {
  return {
    path: `compliance-evaluation-reasons-${source}`,
    name: `settings-compliance-evaluation-reasons-${source}`,
    components: {
      default: ComplianceEvaluationReasonsPage,
    },
  }
}

export const auditSettingsComplianceThresholdsRoute = (source) => {
  return {
    path: `compliance-thresholds-${source}`,
    name: `settings-compliance-thresholds-${source}`,
    components: {
      default: ComplianceThresholdsPage,
    },
    props: {
      default: {
        source,
        caller: source.toUpperCase(),
      },
    },
  }
}

export const auditSettingsQualityFailuresRoute = (source) => {
  return {
    path: `quality-failures-${source}`,
    name: `settings-quality-failures-${source}`,
    components: {
      default: SettingsQualityFailuresPage,
    },
    props: {
      default: {
        source,
        caller: source.toUpperCase(),
      },
    },
  }
}

export const auditSettingsImportSkillsRoute = () => {
  return {
    path: SETTINGS_CARDS_TOKENS.importSkillMatrix.name,
    name: SETTINGS_CARDS_TOKENS.importSkillMatrix.name,
    components: {
      default: SkillMatrixBulkImportPage,
    },
  }
}

export const skillMatrixSettingsPeopleIdentifierFormat = () => {
  return {
    path: SETTINGS_CARDS_TOKENS.peopleIdentifierFormat.name,
    name: SETTINGS_CARDS_TOKENS.peopleIdentifierFormat.name,
    components: {
      default: SettingsSkillMatrixPeopleIdentifierFormatPage,
    },
  }
}

export const auditSettingsNoCompliancesRoute = (source) => {
  return {
    path: `no-compliances-${source}`,
    name: `settings-no-compliances-${source}`,
    components: {
      default: SettingsNoCompliancesPage,
    },
    props: {
      default: {
        source,
        caller: source.toUpperCase(),
      },
    },
  }
}

export const auditSettingsTemplateAssigmentRoute = (source) => {
  return {
    path: SETTINGS_CARDS_TOKENS.auditsTemplateAssignmentConfiguration.name(source),
    name: SETTINGS_CARDS_TOKENS.auditsTemplateAssignmentConfiguration.name(source),
    components: {
      back: BackButton,
      default: LPATemplateAssignmentPage,
      header: HeaderFactoryStructure,
      filters: RemoteFilters,
    },
    props: {
      back: { to: SETTINGS_CARDS_TOKENS.settingsOverview.name },
      default: { caller: source.toUpperCase(), source },
      header: { caller: source.toUpperCase(), source },
      filters: { filterURL: TEMPLATE_FILTERS },
    },
  }
}

export const auditSettingsPlannerConfiguration = (source) => {
  return {
    path: SETTINGS_CARDS_TOKENS.auditsPlannerConfiguration.name(source),
    name: SETTINGS_CARDS_TOKENS.auditsPlannerConfiguration.name(source),
    components: {
      default: SettingsAuditsPlannerConfiguration,
    },
    props: {
      default: { source },
    },
  }
}

export const auditSettingsSubtypesConfiguration = (source) => {
  return {
    path: SETTINGS_CARDS_TOKENS.auditsSubtypesConfiguration.name(source) + '/:origin',
    name: SETTINGS_CARDS_TOKENS.auditsSubtypesConfiguration.name(source),
    components: {
      default: SettingsCategories,
    },
    props: {
      default: { source },
    },
  }
}

export const auditSettingsSubtypesDetails = (source) => {
  return {
    path: URL_BASE_AUDIT_SUBSOURCES + `-${source}` + '/:origin' + '/:id',
    name: URL_BASE_AUDIT_SUBSOURCES + `-${source}`,
    components: {
      default: SettingsCategoriesDetailsPage,
    },
    props: {
      default: { source },
    },
  }
}

export const settingsRoutes = [
  {
    path: '/settings',
    name: 'settings',
    component: SettingsPage,
    children: [
      {
        path: SETTINGS_CARDS_TOKENS.settingsOverview.name,
        name: SETTINGS_CARDS_TOKENS.settingsOverview.name,
        components: {
          default: SettingsOverviewPage,
        },
        props: { default: { source: '' } },
      },
      {
        path: 'standard-permissions',
        name: SETTINGS_CARDS_TOKENS.visualStandardPermissions.name,
        components: {
          default: PermissionsPage,
        },
      },
      {
        path: SETTINGS_CARDS_TOKENS.visualStandardViewerConfiguration.name,
        name: SETTINGS_CARDS_TOKENS.visualStandardViewerConfiguration.name,
        components: {
          default: SettingsStandardViewer,
        },
      },
      {
        path: SETTINGS_CARDS_TOKENS.visualStandardErgonomicsLevelsConfiguration.name,
        name: SETTINGS_CARDS_TOKENS.visualStandardErgonomicsLevelsConfiguration.name,
        components: {
          default: SettingsStandardErgonomicsLevels,
        },
      },
      {
        path: SETTINGS_CARDS_TOKENS.visualStandardErgonomicsLevelsConfiguration.name + '/:id',
        name: SETTINGS_CARDS_TOKENS.visualStandardErgonomicsLevelsConfiguration.children.details,
        props: {
          default: (routerInstance) => {
            return {
              id: Number(routerInstance.params.id),
            }
          },
        },
        components: {
          default: SettingsStandardErgonomicsLevelDetail,
        },
      },
      {
        path: SETTINGS_CARDS_TOKENS.visualStandardProductionConfigurations.name,
        name: SETTINGS_CARDS_TOKENS.visualStandardProductionConfigurations.name,
        components: {
          default: SettingsStandardProductionConfigurationsList,
        },
      },
      {
        path: SETTINGS_CARDS_TOKENS.visualStandardProductionConfigurations.name + '/:id',
        name: SETTINGS_CARDS_TOKENS.visualStandardProductionConfigurations.children.details,
        props: {
          default: (routerInstance) => ({ id: Number(routerInstance.params.id) }),
        },
        components: {
          default: SettingsStandardProductionConfigurationDetails,
        },
      },
      {
        path: SETTINGS_CARDS_TOKENS.standardAbilityCertifications.name,
        name: SETTINGS_CARDS_TOKENS.standardAbilityCertifications.name,
        components: {
          default: SettingsStandardAbilityCertifications,
        },
      },
      {
        path: SETTINGS_CARDS_TOKENS.standardAbilityCertifications.name + '/:id',
        name: SETTINGS_CARDS_TOKENS.standardAbilityCertifications.children.details,
        props: {
          default: (routerInstance) => ({ id: Number(routerInstance.params.id) }),
        },
        components: {
          default: SettingsStandardAbilityCertificateDetail,
        },
      },
      {
        path: SETTINGS_CARDS_TOKENS.visualStandardIndicatorsAndChartsConfiguration.name,
        name: SETTINGS_CARDS_TOKENS.visualStandardIndicatorsAndChartsConfiguration.name,
        components: {
          default: SettingsStandardKpisCharts,
        },
      },
      {
        path: 'problem-solving',
        name: SETTINGS_CARDS_TOKENS.problemSolvingConfiguration.name,
        components: {
          default: SettingsProblemSolvingFields,
        },
        props: { default: { source: PROBLEM_RESOLUTION_SOURCE } },
      },
      {
        path: 'mtools-mtools',
        name: SETTINGS_CARDS_TOKENS.problemSolvingMTool.name,
        components: {
          default: SettingsTemplates,
        },
        props: { default: { source: SOURCE_MTOOL } },
      },
      {
        path: 'mtools-sixmtools',
        name: SETTINGS_CARDS_TOKENS.problemSolving6MTool.name,
        components: {
          default: SettingsTemplates,
        },
        props: { default: { source: SOURCE_SIXMTOOL } },
      },
      {
        path: 'problem-solving-causetool',
        name: SETTINGS_CARDS_TOKENS.problemSolvingAnalysisTool.name,
        components: {
          default: SettingsProblemSolvingCauseTool,
        },
        props: { default: { source: PROBLEM_RESOLUTION_SOURCE } },
      },
      {
        path: 'action-plan-efficiency-config',
        name: SETTINGS_CARDS_TOKENS.problemSolvingActionPlanEfficiencyConfiguration.name,
        components: {
          default: SettingsActionPlanEfficiencyConfiguration,
        },
      },
      {
        path: 'problem-solving-charts-config',
        name: SETTINGS_CARDS_TOKENS.problemSolvingChartsTablesConfiguration.name,
        components: {
          default: ChartsTablesConfigurationPage,
        },
      },
      {
        path: 'documentation-review',
        name: SETTINGS_CARDS_TOKENS.problemSolvingDocReview.name,
        components: {
          default: SettingsProblemSolvingDocumentationReview,
        },
        props: { default: { source: PROBLEM_RESOLUTION_SOURCE } },
      },
      {
        path: 'presentation-notifications',
        name: SETTINGS_CARDS_TOKENS.presentationNotification.name,
        components: {
          default: SettingsPresentationNotifications,
        },
        props: { default: { source: PROBLEM_RESOLUTION_SOURCE } },
      },
      {
        path: SETTINGS_CARDS_TOKENS.productionFormatCreation.name,
        name: SETTINGS_CARDS_TOKENS.productionFormatCreation.name,
        components: {
          header: HeaderFactoryStructure,
          filters: RemoteFilters,
          default: SettingsProductionFormatPage,
        },
        props: {
          header: { source: PRODUCTION_FORMAT_SOURCE, caller: PRODUCTION_FORMAT },
          default: { source: PRODUCTION_FORMAT_SOURCE, caller: PRODUCTION_FORMAT },
          filters: { filterURL: PRODUCTS_FILTERS },
        },
      },
      {
        path: 'product-details/:id',
        name: 'product-details',
        component: SettingsProductionFormatDetailsPage,
        props: { source: PRODUCTION_FORMAT_SOURCE, caller: PRODUCTION_FORMAT },
      },
      {
        path: `${CATEGORIES_SETTINGS_ROUTE}/${HSE_PRIORITIES_ORIGIN}`,
        name: SETTINGS_CARDS_TOKENS.hseRiskPriorities.name,
        components: {
          default: SettingsHSERiskPrioritiesPage,
        },
      },
      {
        path: SETTINGS_CARDS_TOKENS.importProducts.name,
        name: SETTINGS_CARDS_TOKENS.importProducts.name,
        components: {
          default: ProductsBulkImportPage,

        },
        props: {
          header: { source: PRODUCTION_FORMAT_SOURCE, caller: PRODUCTION_FORMAT },
          default: { source: PRODUCTION_FORMAT_SOURCE, caller: PRODUCTION_FORMAT },
          filters: { filterURL: PRODUCTS_FILTERS },
        },
      },
      {
        path: `${CATEGORIES_DETAILS_SETTINGS_ROUTE}/${HSE_PRIORITIES_ORIGIN}/:id`,
        name: SETTINGS_CARDS_TOKENS.hseRiskPriorities.name + '-details',
        components: {
          default: SettingsHSERiskPriorityDetails,
        },
      },
      {
        path: CATEGORIES_SETTINGS_ROUTE + '/:origin',
        name: CATEGORIES_SETTINGS_ROUTE,
        components: {
          default: SettingsCategories,
        },
      },
      {
        path: CATEGORIES_DETAILS_SETTINGS_ROUTE + '/:origin' + '/:id',
        name: CATEGORIES_DETAILS_SETTINGS_ROUTE,
        components: {
          default: SettingsCategoriesDetailsPage,
        },
      },
      {
        path: WEEKLY_MEETING_SETTINGS_ROUTE,
        name: WEEKLY_MEETING_SETTINGS_ROUTE,
        components: {
          default: SettingsWeeklyMeeting,
        },
      },
      {
        path: SETTINGS_CARDS_TOKENS.gembaWalkAssessmentsGraph.name,
        name: SETTINGS_CARDS_TOKENS.gembaWalkAssessmentsGraph.name,
        components: {
          default: SettingsAssessmentHistoryGraphPage,
        },
        props: {
          default: { configurationKeyName: CONFIGURATION_KEYS.GEMBA_WALK_NUMBER_OF_ASSESSMENTS_RESULT },
        },
      },
      {
        path: SETTINGS_CARDS_TOKENS.gembaWalkPreviousCommentsTime.name,
        name: SETTINGS_CARDS_TOKENS.gembaWalkPreviousCommentsTime.name,
        components: {
          default: SettingsPreviousCommentsTime,
        },
        props: {
          default: { configurationKeyName: CONFIGURATION_KEYS.GEMBA_WALK_PREVIOUS_COMMENTS_TIME_CONFIG },
        },
      },
      {
        path: SETTINGS_CARDS_TOKENS.gembaWalkChartConfiguration.name,
        name: SETTINGS_CARDS_TOKENS.gembaWalkChartConfiguration.name,
        components: {
          default: SettingsGWCheckpointsChartConfigurationPage,
        },
      },
      {
        path: SETTINGS_CARDS_TOKENS.gembaWalkByCheckpointChartConfiguration.name,
        name: SETTINGS_CARDS_TOKENS.gembaWalkByCheckpointChartConfiguration.name,
        components: {
          default: SettingsGWByCheckpointsChartConfigurationPage,
        },
        props: {
          default: { configurationKeyName: CONFIGURATION_KEYS.GEMBA_WALK_NUMBER_OF_ASSESSMENTS_RESULT },
        },
      },
      {
        path: SETTINGS_CARDS_TOKENS.problemSolvingCloseTools.name,
        name: SETTINGS_CARDS_TOKENS.problemSolvingCloseTools.name,
        component: SettingsProblemCloseToolsConfiguration,
        props: { source: 'audits' },
      },
      {
        path: SETTINGS_CARDS_TOKENS.problemSolvingActionCategories.name,
        name: SETTINGS_CARDS_TOKENS.problemSolvingActionCategories.name,
        component: SettingsProblemSolvingActionCategoriesPage,
      },
      {
        path: `charts-config-master-audit`,
        name: `settings-chartstable-config-master-audit`,
        components: {
          default: AuditsChartsConfigurationPage,
        },
        props: {
          default: {
            source: MASTER_AUDIT_SOURCE,
          },
        },
      },
      {
        path: SETTINGS_CARDS_TOKENS.okFirstPartCategories.name,
        name: SETTINGS_CARDS_TOKENS.okFirstPartCategories.name,
        components: {
          default: SettingsCategories,
        },
      },
      {
        path: SETTINGS_CARDS_TOKENS.okFirstPartOverviewConfig.name,
        name: SETTINGS_CARDS_TOKENS.okFirstPartOverviewConfig.name,
        components: {
          default: SettingsOkFirstPartChartConfigurationPage,
        },
      },
      {
        path: SETTINGS_CARDS_TOKENS.okFirstPartConfigureOptions.name,
        name: SETTINGS_CARDS_TOKENS.okFirstPartConfigureOptions.name,
        components: {
          default: SettingsOkFirstPartOptionsPage,
        },
      },
      {
        path: SETTINGS_CARDS_TOKENS.okFirstPartEmails.name,
        name: SETTINGS_CARDS_TOKENS.okFirstPartEmails.name,
        components: {
          default: SettingsOkFirstPartEmailsPage,
        },
      },
      {
        path: SETTINGS_CARDS_TOKENS.okFirstPartByCheckpointChartConfiguration.name,
        name: SETTINGS_CARDS_TOKENS.okFirstPartByCheckpointChartConfiguration.name,
        components: {
          default: SettingsOkFirstPartByCheckpointChartConfigurationPage,
        },
      },
      {
        path: 'ok-first-part',
        component: OkFirstPartPage,
        redirect: { name: SETTINGS_CARDS_TOKENS.okFirstPartTaskDefinition.name },
        children: [
          {
            path: 'definition',
            name: constants.OK_FIRST_PART_TASK_DEFINITION_ROUTE_NAME,
            components: {
              default: OkFirstPartDefinitionList,
              header: HeaderFactoryStructure,
              filters: RemoteFilters,
            },
            props: {
              default: { source: OK_FIRST_PART_SOURCE },
              header: { caller: OK_FIRST_PART, source: OK_FIRST_PART_SOURCE },
              filters: { filterURL: OK_FIRST_PART_CHECK_POINT_FILTERS },
            },
          },
          {
            path: 'definition/:versionGroupId',
            name: constants.OK_FIRST_PART_CHECKPOINT_VERSIONS_ROUTE_NAME,
            component: OkFirstPartCheckpointVersionsPage,
            props: { source: OK_FIRST_PART_SOURCE },
          },
          {
            path: 'definition/:versionGroupId/version/:checkpointId',
            name: constants.OK_FIRST_PART_DETAILS_ROUTE_NAME,
            component: OkFirstPartDefinitionDetails,
            props: { source: OK_FIRST_PART_SOURCE },
          },
          {
            path: 'definition/version/new',
            name: constants.OK_FIRST_PART_CREATION_ROUTE_NAME,
            component: OkFirstPartDefinitionDetails,
            props: { source: OK_FIRST_PART_SOURCE },
          },
        ],
      },
      {
        path: SETTINGS_CARDS_TOKENS.diagnosisRolePermissions.name,
        name: SETTINGS_CARDS_TOKENS.diagnosisRolePermissions.name,
        components: {
          default: SettingsDiagnosisRolePermissionssPage,
        },
      },
      {
        path: SETTINGS_CARDS_TOKENS.consolidatedReportRolePermissions.name,
        name: SETTINGS_CARDS_TOKENS.consolidatedReportRolePermissions.name,
        components: {
          default: SettingsConsolidatedReportRolePermissionssPage,
        },
      },
      {
        path: SETTINGS_CARDS_TOKENS.fundamentalTarget.name,
        name: SETTINGS_CARDS_TOKENS.fundamentalTarget.name,
        components: {
          header: HeaderFactoryStructure,
          default: SettingsFundamentalTargetPage,
        },
        props: {
          header: { caller: DIAGNOSIS_LINE },
          default: { caller: DIAGNOSIS_LINE },
        },
      },
      {
        path: SETTINGS_CARDS_TOKENS.selfAssessmentsOverviewConfig.name,
        name: SETTINGS_CARDS_TOKENS.selfAssessmentsOverviewConfig.name,
        components: {
          default: SettingsSelfAssessmentOverviewPage,
        },
      },
      {
        path: SETTINGS_CARDS_TOKENS.tpmConfigureOptions.name,
        name: SETTINGS_CARDS_TOKENS.tpmConfigureOptions.name,
        components: {
          default: SettingsTPMCheckpointOptionsPage,
        },
      },
      {
        path: SETTINGS_CARDS_TOKENS.tpmAssessmentHistoryGraph.name,
        name: SETTINGS_CARDS_TOKENS.tpmAssessmentHistoryGraph.name,
        components: {
          default: SettingsAssessmentHistoryGraphPage,
        },
        props: {
          default: { configurationKeyName: CONFIGURATION_KEYS.TASK_MANAGER_CHECKPOINT_HISTORY_LIMIT },
        },
      },
      {
        path: SETTINGS_CARDS_TOKENS.tpmPreviousCommentsTime.name,
        name: SETTINGS_CARDS_TOKENS.tpmPreviousCommentsTime.name,
        components: {
          default: SettingsPreviousCommentsTime,
        },
        props: {
          default: { configurationKeyName: CONFIGURATION_KEYS.TPM_PREVIOUS_COMMENTS_TIME_CONFIG },
        },
      },
      {
        path: SETTINGS_CARDS_TOKENS.tpmSuperCategories.name,
        name: SETTINGS_CARDS_TOKENS.tpmSuperCategories.parentName,
        redirect: { name: SETTINGS_CARDS_TOKENS.tpmSuperCategoriesList.name },
        components: {
          default: SettingsSuperCategoriesPage,
        },
        children: [
          {
            path: 'list/:origin/',
            name: SETTINGS_CARDS_TOKENS.tpmSuperCategoriesList.name,
            components: {
              default: SettingsSuperCategories,
            },
            props: {
              default: { origin: SUPER_CATEGORIES },
            },
          },
          {
            path: 'list/:origin/:id',
            name: SETTINGS_CARDS_TOKENS.tpmSuperCategoriesDetails.name,
            components: {
              default: SettingsSuperCategoriesDetails,
            },
            props: {
              default: { origin: SUPER_CATEGORIES },
            },
          },
        ],
      },
      {
        path: 'tasks-definition',
        component: TaskManagerPage,
        redirect: { name: SETTINGS_CARDS_TOKENS.tpmTasksCreation.name },
        children: [
          {
            path: 'list',
            name: SETTINGS_CARDS_TOKENS.tpmTasksCreation.name,
            components: {
              header: HeaderFactoryStructure,
              filters: RemoteFilters,
              default: TasksList,
            },
            props: {
              header: { caller: TASK_MANAGER_ASSIGNMENT },
              default: { source: TASK_MANAGER_SOURCE },
            },
          },
          {
            path: 'list/:id',
            name: constants.TASK_DETAILS_ROUTE_NAME,
            component: TaskDetails,
            props: { source: TASK_MANAGER_SOURCE },
          },
          {
            path: 'new',
            name: constants.TASK_NEW_ROUTE_NAME,
            component: TaskDetails,
            props: { source: TASK_MANAGER_SOURCE },
          },
          {
            path: 'tasks-assignment',
            name: SETTINGS_CARDS_TOKENS.tpmTasksAssignment.name,
            components: {
              header: HeaderFactoryStructure,
              filters: RemoteFilters,
              default: TasksAssignment,
            },
            props: {
              header: { caller: TASK_MANAGER_ASSIGNMENT },
              default: { source: TASK_MANAGER_SOURCE, caller: TASK_MANAGER_ASSIGNMENT },
            },
          },
          {
            path: 'tasks-groups',
            name: SETTINGS_CARDS_TOKENS.tpmTasksGroups.name,
            components: {
              header: HeaderFactoryStructure,
              default: TaskGroupsPage,
            },
            props: {
              header: { caller: TASK_MANAGER_ASSIGNMENT, multiple: false },
              default: { source: TASK_MANAGER_SOURCE, caller: TASK_MANAGER_ASSIGNMENT },
            },
          },
        ],
      },
    ],
  },
]

export const dailyRoundCheckpointsRoutes = [
  {
    path: '/dr-checkpoints',
    name: constants.DAILY_ROUND_CHECKPOINTS_ROUTE_NAME,
    component: DRCheckpointsPage,
    children: [
      {
        shownInMenu: true,
        path: 'overview',
        name: constants.DAILY_ROUND_CHECKPOINTS_OVERVIEW_ROUTE_NAME,
        components: {
          default: DRCheckpointsOverviewPage,
          filters: RemoteFilters,
        },
        props: {
          default: { source: DAILYROUND_CHECKPOINT },
        },
      },
      {
        shownInMenu: true,
        path: 'list',
        name: constants.DAILY_ROUND_CHECKPOINTS_LIST_ROUTE_NAME,
        components: {
          default: DRCheckpointsList,
          filters: RemoteFilters,
        },
        props: {
          default: { source: DAILYROUND_CHECKPOINT },
        },
      },
      {
        shownInMenu: false,
        path: 'new',
        name: constants.DAILY_ROUND_CHECKPOINTS_CREATION_ROUTE_NAME,
        components: {
          default: DRCheckpointsDetails,
        },
        props: {
          default: { source: DAILYROUND_CHECKPOINT },
        },
      },
      {
        shownInMenu: false,
        path: 'list/:id',
        name: constants.DAILY_ROUND_CHECKPOINTS_DETAILS_ROUTE_NAME,
        components: {
          default: DRCheckpointsDetails,
        },
        props: {
          default: { source: DAILYROUND_CHECKPOINT },
        },
      },
      {
        shownInMenu: true,
        path: 'rounds',
        name: constants.DAILY_ROUND_LIST_ROUTE_NAME,
        components: {
          default: DRCheckpointsRoundsList,
          filters: RemoteFilters,
        },
        props: {
          default: { source: DAILYROUND_CHECKPOINT },
        },
      },
      {
        shownInMenu: false,
        path: 'rounds/:id',
        name: constants.DAILY_ROUND_DETAILS_ROUTE_NAME,
        components: {
          default: DRCheckpointsRoundsDetails,
        },
        props: {
          default: { source: DAILYROUND_CHECKPOINT },
        },
      },
      {
        shownInMenu: false,
        path: 'rounds/:scheduleId/entry/:scheduleEntryId',
        name: constants.DAILY_ROUND_ACTIVITIES_DETAILS_ROUTE_NAME,
        components: {
          default: ActivityDetails,
        },
        props: {
          default: { source: DAILYROUND_CHECKPOINT },
        },
      },
      {
        shownInMenu: true,
        path: 'weekly-rounds/:id?',
        name: constants.DAILY_ROUND_WEEKLY_ROUTE_NAME,
        components: {
          default: DRWeeklyRoundReview,
          filters: RemoteFilters,
        },
        props: {
          default: (routerInstance) => {
            const params = { source: DAILYROUND_CHECKPOINT }
            if (routerInstance.params?.id) {
              params.weeklyMeetingId = Number(routerInstance.params.id)
            }
            return params
          },
        },
      },
    ],
  },
]

export const loogBookRoutes = [
  {
    path: '/logbook',
    name: constants.DAILY_ROUND_LOGBOOK_ROUTE_NAME,
    component: DRCheckpointsPage,
    children: [
      {
        shownInMenu: true,
        path: 'detail',
        name: constants.DAILY_ROUND_LOGBOOK_ROUTE_LIST_NAME,
        components: {
          header: HeaderFactoryStructure,
          default: DRLogBook,
          filters: RemoteFilters,
        },
        props: {
          header: { caller: DAILYROUND_MESSAGES },
          default: { caller: DAILYROUND_MESSAGES, source: DAILYROUND_CHECKPOINT },
        },
      },
      {
        shownInMenu: false,
        path: 'detail/new',
        name: constants.DAILY_ROUND_LOGBOOK_NEW_ROUTE_NAME,
        components: {
          default: DRLogBookDetails,
        },
        props: {
          default: {
            caller: DAILYROUND_MESSAGES,
          },
        },
      },
      {
        shownInMenu: false,
        path: 'detail/:id',
        name: constants.DAILY_ROUND_LOGBOOK_DETAILS_ROUTE_NAME,
        components: {
          default: DRLogBookDetails,
        },
        props: {
          default: {
            caller: DAILYROUND_MESSAGES,
          },
        },
      },
    ],
  },
]

export const gembaWalkCheckpointsRoutes = [
  {
    path: '/gw-checkpoints',
    name: constants.GEMBA_WALK_CHECKPOINTS_ROUTE_NAME,
    component: GWCheckpointsPage,
    children: [
      {
        shownInMenu: true,
        path: 'overview',
        name: constants.GEMBA_WALK_CHECKPOINTS_OVERVIEW_ROUTE_NAME,
        components: {
          default: GWCheckpointsOverviewPage,
        },
        props: {
          default: { caller: GEMBA_WALK, source: GEMBA_WALK_TEMPLATE },
        },
      },
      {
        shownInMenu: true,
        path: 'list',
        name: constants.GEMBA_WALK_CHECKPOINTS_LIST_ROUTE_NAME,
        components: {
          default: GWCheckpointsList,
          filters: RemoteFilters,
          header: HeaderFactoryStructure,
        },
        props: {
          default: { caller: GEMBA_WALK, source: GEMBA_WALK_TEMPLATE },
          header: { caller: GEMBA_WALK },
        },
      },
      {
        shownInMenu: false,
        path: 'new',
        name: constants.GEMBA_WALK_CHECKPOINTS_CREATION_ROUTE_NAME,
        components: {
          default: GWCheckpointsDetails,
        },
        props: {
          default: { source: GEMBA_WALK_TEMPLATE },
        },
      },
      {
        shownInMenu: false,
        path: 'list/:id',
        name: constants.GEMBA_WALK_CHECKPOINTS_DETAILS_ROUTE_NAME,
        components: {
          default: GWCheckpointsDetails,
        },
        props: {
          default: { source: GEMBA_WALK_TEMPLATE },
        },
      },
      {
        shownInMenu: true,
        path: 'rounds',
        name: constants.GEMBA_WALK_LIST_ROUTE_NAME,
        components: {
          default: GWCheckpointsSchedulesList,
          filters: RemoteFilters,
        },
        props: {
          default: { source: GEMBA_WALK_TEMPLATE },
        },
      },
      {
        shownInMenu: false,
        path: 'rounds/:id',
        name: constants.GEMBA_WALK_DETAILS_ROUTE_NAME,
        components: {
          default: GWCheckpointsSchedulesDetails,
        },
        props: {
          default: { source: GEMBA_WALK_TEMPLATE },
        },
      },
      {
        shownInMenu: false,
        path: 'rounds/:roundId/activity/:id',
        name: constants.GEMBA_WALK_ACTIVITIES_DETAILS_ROUTE_NAME,
        components: {
          default: GWCheckpointsSchedulesActivityDetails,
        },
        props: {
          default: { source: GEMBA_WALK_TEMPLATE },
        },
      },
      {
        shownInMenu: false,
        path: 'assessments/:assessmentId/:kpiCardSource',
        name: constants.GEMBA_WALK_ASSESSMENT_DETAILS_ROUTE_NAME,
        components: {
          default: GWCheckpointsSchedulesActivityDetails,
        },
        props: {
          default: route => ({
            source: GEMBA_WALK_TEMPLATE,
            kpiCardSource: parseInt(route.params.kpiCardSource),
          }),
        },
      },
      {
        shownInMenu: true,
        path: 'face-to-face',
        name: constants.FACE_TO_FACE_ROUTE_NAME,
        components: {
          default: FaceToFaceList,
          filters: RemoteFilters,
        },
        props: {
          default: { caller: GEMBA_WALK, source: GEMBA_WALK_TEMPLATE },
        },
      },
      {
        shownInMenu: false,
        path: 'face-to-face/:id',
        name: constants.FACE_TO_FACE_DETAILS_ROUTE_NAME,
        component: FaceToFaceDetails,
        props: { source: GEMBA_WALK_TEMPLATE },
      },
      {
        shownInMenu: true,
        path: 'by-checkpoint/list',
        name: constants.GEMBA_WALK_BY_CHECKPOINT_LIST_ROUTER_NAME,
        components: {
          default: GWByCheckpointListPage,
          filters: RemoteFilters,
          header: HeaderFactoryStructure,
        },
        props: {
          default: { source: GEMBA_WALK_TEMPLATE },
          header: { caller: GEMBA_WALK },
        },
      },
      {
        shownInMenu: false,
        path: 'by-checkpoint/list/:id',
        name: constants.GEMBA_WALK_BY_CHECKPOINT_DETAILS_ROUTER_NAME,
        components: {
          default: GWByCheckpointDetailsPage,
        },
        props: {
          default: { caller: GEMBA_WALK, source: GEMBA_WALK_TEMPLATE },
        },
      },
    ],
  },
]

export const virtualTrainingViewerRoutes = [
  {
    path: '/virtual-training',
    name: DASHBOARD_MODULE_TOKENS.virtualTraining.name,
    component: VirtualTrainingPage,
    children: [
      {
        shownInMenu: true,
        path: 'viewer',
        name: DASHBOARD_MODULE_TOKENS.variantViewer.name,
        components: {
          default: VariantViewerPage,
          header: HeaderFactoryStructure,
        },
        props: {
          default: { caller: VT_RESULTS },
          header: { caller: VT_RESULTS, anyLevelClickable: false },
        },
      },
      {
        shownInMenu: true,
        path: 'evaluation',
        name: DASHBOARD_MODULE_TOKENS.variantEvaluation.name,
        components: {
          default: VariantEvaluationPage,
        },
        props: {
          default: { caller: VT_RESULTS, source: VT_SOURCE },
        },
      },
      {
        shownInMenu: true,
        path: 'overview',
        name: DASHBOARD_MODULE_TOKENS.virtualTrainingOverview.name,
        components: {
          default: VTOverview,
          header: HeaderFactoryStructure,
          filters: RemoteFilters,
          charts: VTCharts,
        },
        props: {
          default: { caller: VT_RESULTS },
          header: { caller: VT_RESULTS },
          charts: { caller: VT_RESULTS },
        },
      },
      {
        shownInMenu: true,
        path: 'test-result',
        name: DASHBOARD_MODULE_TOKENS.virtualTrainingTestResult.name,
        components: {
          default: VirtualTrainingTestResultsPage,
          header: HeaderFactoryStructure,
        },
        props: {
          default: { caller: VT_RESULTS },
          header: { caller: VT_RESULTS },
        },
      },
      {
        shownInMenu: true,
        path: 'test-state',
        name: DASHBOARD_MODULE_TOKENS.virtualTrainingTestState.name,
        components: {
          default: VirtualTrainingStatePage,
          header: HeaderFactoryStructure,
        },
        props: {
          default: { caller: VT_RESULTS },
          header: { caller: VT_RESULTS },
        },
      },
    ],
  },
]

export const pendingRoutes = [
  {
    path: '/pending',
    name: 'pending',
    component: PendingPage,
    children: [
      {
        path: 'items',
        name: 'pending-items',
        component: PendingItems,
      },
    ],
  },
]

export const myCalendar = [
  {
    path: '/my-calendar',
    name: 'my-calendar',
    component: MyCalendarPage,
    children: [
      {
        path: 'overview',
        name: 'my-calendar-overview',
        components: {
          default: MyCalendarOverview,
          header: HeaderFactoryStructure,
        },
        props: {
          default: { caller: MY_CALENDAR },
          header: { caller: MY_CALENDAR },
        },
      },
    ],
  },
]

export function createNewRoutesAudits (source) {
  const auditPath = `/${source}`
  return [
    {
      name: `${source}-section`,
      path: auditPath,
      component: AuditsPage,
      props: { source },
      children: [
        {
          path: 'list',
          name: `${source}-list`,
          components: {
            default: AuditsListPage,
            header: HeaderFactoryStructure,
            filters: AuditsFilters,
          },
          props: {
            default: { caller: source.toUpperCase(), source },
            header: { caller: source.toUpperCase() },
            filters: { source },

          },
        },
        {
          path: 'list/:id',
          name: source + '-details',
          component: DetailsPage,
          props: {
            source,
          },
        },
        {
          path: 'overview',
          name: source + '-overview',
          components: {
            default: AuditsOverviewPage,
            header: HeaderFactoryStructure,
            filters: AuditsFilters,
          },
          props: {
            default: { caller: source.toUpperCase(), source },
            header: { caller: source.toUpperCase(), source },
            filters: { source },
          },
        },
        {
          path: 'calendar',
          name: source + '-calendar',
          components: {
            default: AuditsCalendarPage,
            header: HeaderFactoryStructure,
            filters: AuditsFilters,
          },
          props: {
            default: { caller: source.toUpperCase(), source },
            header: { caller: source.toUpperCase() },
            filters: { source },
          },
        },
        {
          path: 'defects',
          name: source + '-defects',
          components: {
            default: FiveSDefectsPage,
            header: HeaderFactoryStructure,
            filters: RemoteFilters,
          },
          props: {
            default: { caller: source.toUpperCase(), source: source },
            header: { caller: source.toUpperCase() },
            filters: { filterURL: DEFECTS_FILTERS },
          },
        },
        {
          path: 'defects/:id',
          name: source + '-defects-details',
          component: FiveSDefectsDetailsPage,
          props: { source: source },
        },
        {
          path: 'reference-state',
          name: `${source}-reference-state`,
          components: {
            default: ReferenceState,
            header: HeaderFactoryStructure,
            filters: RemoteFilters,
          },
          props: {
            default: { caller: `${source.toUpperCase()}`, source: source, finalCaller: source.toUpperCase() },
            header: { caller: source.toUpperCase() },
            filters: { filterURL: REFERENCE_STATE_FILTERS },
          },
        },
        {
          path: 'reference-state/:id',
          name: `${source}-reference-state-details`,
          components: {
            default: ReferenceStateTabs,
          },
          props: {
            default: { source: source },
          },
        },
      ],
    },
  ]
}

export const actionRoutes = [
  {
    name: DASHBOARD_MODULE_TOKENS.actions.name,
    path: '/actions',
    component: ActionsPage,
    children: [
      {
        shownInMenu: true,
        path: 'overview',
        name: DASHBOARD_MODULE_TOKENS.actionsOverview.name,
        components: {
          default: ActionsOverviewPage,
          header: HeaderFactoryStructure,
          filters: RemoteFilters,
        },
        props: {
          default: { caller: ACTIONS },
          header: { caller: ACTIONS },
        },
      },
      {
        shownInMenu: true,
        path: 'list',
        name: DASHBOARD_MODULE_TOKENS.actionsList.name,
        components: {
          default: ActionsDetailsPage,
          header: HeaderFactoryStructure,
          filters: RemoteFilters,
        },
        props: {
          default: { caller: ACTIONS },
          header: { caller: ACTIONS },
        },
      },
      {
        shownInMenu: true,
        path: 'follow-up-teams',
        name: DASHBOARD_MODULE_TOKENS.actionsFollowUp.name,
        components: {
          default: ActionsFollowUpTeamsPage,
          header: HeaderFactoryStructure,
          filters: RemoteFilters,
        },
        props: {
          default: { caller: ACTIONS },
          header: { caller: ACTIONS },
        },
      },
      {
        shownInMenu: false,
        path: 'list/:id',
        name: DASHBOARD_MODULE_TOKENS.actionsDetails.name,
        components: {
          default: DetailsAction,
        },
        props: {
          default: route => ({ id: Number(route.params.id) }),
        },
      },
      {
        shownInMenu: true,
        path: 'calendar',
        name: DASHBOARD_MODULE_TOKENS.actionsCalendar.name,
        components: {
          default: ActionsCalendarPage,
          header: HeaderFactoryStructure,
          filters: RemoteFilters,
        },
        props: {
          default: { caller: ACTIONS },
          header: { caller: ACTIONS },
        },
      },
    ],
  },
]

export const lpaRoutes = [
  {
    path: '/master-audits',
    name: DASHBOARD_MODULE_TOKENS.lpa.name,
    component: LPAPage,
    children: [
      {
        shownInMenu: false,
        path: 'list/:id',
        name: 'lpa-audits-details',
        component: DetailsPage,
        props: { source: LPAS_SOURCE },
      },
      {
        shownInMenu: true,
        path: 'overview-audits',
        name: DASHBOARD_MODULE_TOKENS.masterAuditOverview.name,
        components: {
          default: AuditsOverviewPage,
          header: HeaderFactoryStructure,
          filters: AuditsFilters,
        },
        props: {
          default: { caller: LPA, source: LPAS_SOURCE },
          header: { caller: LPA },
          filters: { source: LPAS_SOURCE },
        },
      },
      {
        shownInMenu: true,
        path: 'calendar',
        name: DASHBOARD_MODULE_TOKENS.lpaMasterAuditCalendar.name,
        components: {
          default: AuditsCalendarPage,
          header: HeaderFactoryStructure,
          filters: AuditsFilters,
        },
        props: {
          default: { caller: LPA, source: LPAS_SOURCE },
          header: { caller: LPA },
          filters: { source: LPAS_SOURCE },
        },
      },
    ],
  },
]

export const diagnosisRoutes = [
  {
    path: '/diagnosis',
    name: DASHBOARD_MODULE_TOKENS.diagnosis.name,
    components: {
      default: DiagnosisPage,
    },
    children: [
      {
        shownInMenu: true,
        path: 'overview',
        name: DASHBOARD_MODULE_TOKENS.diagnosisOverview.name,
        components: {
          default: DiagnosisOverviewPage,
          header: HeaderFactoryStructure,
        },
        props: {
          header: { caller: DIAGNOSIS_FACTORY },
        },
      },
      {
        shownInMenu: true,
        path: 'list',
        name: DASHBOARD_MODULE_TOKENS.diagnosisList.name,
        components: {
          default: DiagnosisListPage,
          header: HeaderFactoryStructure,
          filters: RemoteFilters,
        },
        props: {
          default: { caller: DIAGNOSIS_FACTORY },
          header: { caller: DIAGNOSIS_FACTORY },
          filters: { filterURL: DIAGNOSIS_FILTERS },
        },
      },
      {
        shownInMenu: true,
        path: DASHBOARD_MODULE_TOKENS.consolidatedReportCreation.name,
        name: DASHBOARD_MODULE_TOKENS.consolidatedReportCreation.name,
        component: ConsolidatedReportCreation,
        props: { caller: DIAGNOSIS_FACTORY },
      },
      {
        shownInMenu: true,
        path: DASHBOARD_MODULE_TOKENS.consolidatedReportTable.name,
        name: DASHBOARD_MODULE_TOKENS.consolidatedReportTable.name,
        components: {
          filters: RemoteFilters,
          default: ConsolidatedReportTablePage,
        },
        props: {
          default: { caller: DIAGNOSIS_FACTORY },
          filters: { filterURL: CONSOLIDATED_REPORT_FILTERS },
        },
      },
      {
        shownInMenu: false,
        path: 'consolidated-report-detail/:id',
        name: DASHBOARD_MODULE_TOKENS.consolidatedReportDetail.name,
        component: ConsolidatedReportDetail,
        props: { caller: DIAGNOSIS_FACTORY },
      },
      {
        shownInMenu: false,
        path: 'detail/:id',
        components: {
          default: DiagnosisDetailPage,
        },
        children: [
          {
            path: 'fundamental/:fundamental_id',
            name: constants.DIAGNOSIS_DETAIL_ROUTE,
            components: {
              default: FundamentalDetail,
            },
          },
          {
            path: '',
            name: DASHBOARD_MODULE_TOKENS.diagnosisDetails.name,
            components: {
              default: DiagnosisBricks,
            },
          },
        ],
      },
    ],
  },
]

export const consolidatedReportInCorporativeRoutes = [
  {
    path: '/consolidated-reports',
    name: DASHBOARD_MODULE_TOKENS.consolidatedReportInCorp.name,
    components: {
      default: ConsolidatedReportPage,
    },
    children: [
      {
        shownInMenu: true,
        path: 'list',
        name: DASHBOARD_MODULE_TOKENS.consolidatedReportInCorpList.name,
        components: {
          header: HeaderFactoryStructure,
          default: ConsolidatedReportTablePage,
          filters: RemoteFilters,
        },
        props: {
          default: { caller: DIAGNOSIS_LINE },
          header: { caller: DIAGNOSIS_LINE },
          filters: { filterURL: CONSOLIDATED_REPORT_FILTERS },
        },
      },
      {
        shownInMenu: false,
        path: 'list/:id',
        name: DASHBOARD_MODULE_TOKENS.consolidatedReportInCorpDetails.name,
        components: {
          default: ConsolidatedReportDetail,
        },
        props: {
          default: { caller: DIAGNOSIS_LINE },
        },
      },
    ],
  },
]

export const standardWorkReviewRoutes = [
  {
    path: '/standard-work-review',
    name: DASHBOARD_MODULE_TOKENS.swr.name,
    components: {
      default: StandardWorkReviewPage,
    },
    children: [
      {
        shownInMenu: true,
        path: 'overview',
        name: DASHBOARD_MODULE_TOKENS.swrOverview.name,
        components: {
          default: SWROverviewPage,
          header: HeaderFactoryStructure,
          filters: RemoteFilters,
        },
        props: {
          default: { caller: STANDARD_WORK_REVIEW, source: SWR_SOURCE },
          header: { caller: STANDARD_WORK_REVIEW },
        },
      },
      {
        shownInMenu: true,
        path: 'list',
        name: DASHBOARD_MODULE_TOKENS.swrList.name,
        components: {
          default: SWRListPage,
          header: HeaderFactoryStructure,
          filters: RemoteFilters,
        },
        props: {
          header: { caller: STANDARD_WORK_REVIEW },
        },
      },
      {
        shownInMenu: true,
        configKeyForEnablingRoute: CONFIGURATION_KEYS.IS_CAPABILITY_TO_REACH_SWT_ENABLED,
        path: 'variability',
        name: DASHBOARD_MODULE_TOKENS.swrVariability.name,
        components: {
          default: SWRVariabilityPage,
          header: HeaderFactoryStructure,
          filters: RemoteFilters,
        },
        props: {
          default: { caller: STANDARD_WORK_REVIEW, source: SWR_SOURCE },
          header: { caller: STANDARD_WORK_REVIEW },
        },
      },
      {
        shownInMenu: true,
        path: 'calendar',
        name: DASHBOARD_MODULE_TOKENS.swaCalendar.name,
        components: {
          default: SWACalendarPage,
          header: HeaderFactoryStructure,
          filters: RemoteFilters,
        },
        redirect: { name: DASHBOARD_MODULE_TOKENS.swaMonthlyCalendar.name },
        props: {
          header: { caller: STANDARD_WORK_REVIEW, multiple: false },
        },
        children: [
          {
            path: DASHBOARD_MODULE_TOKENS.swaWeeklyCalendar.name,
            name: DASHBOARD_MODULE_TOKENS.swaWeeklyCalendar.name,
            component: SWAWeeklyCalendarPage,
            props: { caller: STANDARD_WORK_REVIEW },
          },
          {
            path: DASHBOARD_MODULE_TOKENS.swaMonthlyCalendar.name,
            name: DASHBOARD_MODULE_TOKENS.swaMonthlyCalendar.name,
            component: SWAMonthlyCalendar,
            props: { caller: STANDARD_WORK_REVIEW },
          },
        ],
      },
      {
        shownInMenu: false,
        path: 'detail/:id',
        name: constants.STANDARD_WORK_AUDIT_DETAIL_ROUTE_NAME,
        components: {
          default: SWRDetailPage,
        },
        props: {
          default: { source: SWR_SOURCE },
        },
      },
      {
        shownInMenu: false,
        path: 'detail/:id/cycle/:cycle',
        name: 'swr-evaluation-detail',
        component: SWREvaluationDetailPage,
        props: { source: SWR_SOURCE },
      },
    ],
  },
]

export const commonRoutes = [
  {
    path: '/overview',
    name: DASHBOARD_MODULE_TOKENS.overview.name,
    components: {
      default: OverviewPage,
      header: HeaderFactoryStructure,
    },
    props: {
      default: { caller: OVERVIEW },
      header: { caller: OVERVIEW },
    },
  },
  ...accountRoutes,
]
